












































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import {
  getMaterials,
  getDashboard,
  getMaterialsStats,
  // getPurchaseOrderItemsUnion,
  getPurchaseOrderStats,
  getPurchaseRequests,
} from '@/api';
// import dashboardOption from '@/table/PurchaseOrder/dashboard';
import material from '@/table/Store/material-dashboard';

const StoreDashboard = defineComponent({
  setup(props) {
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();

    const materials = ref([]);

    const purchaseOrderItemStatusCounter = reactive({
      PENDING: 0,
      PENDING_TODAY: 0,
      LOW_MAT: 0,
      MAT_COUNT: 0,
      OVERDUE: 0,
      PENDING_PURCHASE: 0,
      PENDING_RECEIVE: 0,
      WAITING: 0,
    });

    const computedPurchaseStatusChart = computed(() => ([
      { name: 'รายการรอสั่งซื้อ', data: purchaseOrderItemStatusCounter.PENDING_PURCHASE || 0, color: 'green' },
      { name: 'รอยืนยันได้รับสินค้า', data: purchaseOrderItemStatusCounter.PENDING_RECEIVE || 0, color: 'blue' },
      { name: 'เกินกำหนดจัดส่ง', data: purchaseOrderItemStatusCounter.OVERDUE || 0, color: 'red' },
    ]));

    async function getDashboardData() {
      const { total } = (await getPurchaseRequests({ status: 'PENDING' })).data;
      const { waiting, overdueItem, notFulfilledItem } = (await getPurchaseOrderStats({}));
      // purchaseOrderItemStatusCounter.WAITING = waiting;
      purchaseOrderItemStatusCounter.OVERDUE = overdueItem || 0;
      purchaseOrderItemStatusCounter.PENDING_RECEIVE = waiting || 0;
      purchaseOrderItemStatusCounter.PENDING_PURCHASE = total || 0;
      purchaseOrderItemStatusCounter.WAITING = notFulfilledItem || 0;

      const { lowAmountMat, materials: statsResult } = (await getDashboard({
        materials: true,
        overduePoItems: true,
        lowAmountMat: true,
      }));
      purchaseOrderItemStatusCounter.PENDING = statsResult.waiting || 0;
      purchaseOrderItemStatusCounter.PENDING_TODAY = statsResult.waitingToday || 0;
      purchaseOrderItemStatusCounter.LOW_MAT = statsResult.lowMat || 0;
      purchaseOrderItemStatusCounter.MAT_COUNT = statsResult.matCount || 0;
      materials.value = lowAmountMat.filter((mat: any) => mat.code !== '');
    }
    const stats = reactive({
      total: 0,
      lowAmount: 0,
      purchasing: 0,
    });

    async function getStats() {
      const { total, lowAmount, purchasing } = await getMaterialsStats({ date: useFormat.date(new Date()).computerShortDate() });
      stats.total = total;
      stats.lowAmount = lowAmount;
      stats.purchasing = purchasing;
    }

    onMounted(async () => {
      await getStats();
      await getDashboardData();
    });

    return {
      toDate,

      stats,
      materials,
      getMaterials,
      materialTableOptionsDashboard: material,

      // dashboardOption,
      // getPurchaseOrderItemsUnion,
      computedPurchaseStatusChart,

      purchaseOrderItemStatusCounter,
    };
  },
});

export default StoreDashboard;
